// https://stackoverflow.com/questions/9237044/async-loaded-scripts-with-domcontentloaded-or-load-event-handlers-not-being-call#answer-50026257
/* *** DOM Ready ******************************** */
// Checks if dom ready or if completed
// Usage:
// DOMReady(function() {
  // Stuff to launch
// });
var DOMReady = function(callback) {
  if (document.readyState === "interactive" || document.readyState === "complete") {
      callback();
  } else if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', callback());
  } else if (document.attachEvent) {
      document.attachEvent('onreadystatechange', function() {
          if (document.readyState != 'loading') {
              callback();
          }
      });
  }
};